import { use, useEffect, useState } from 'react';
import { Image } from '../../../Image/Image';
import { MoreInfo } from '../../MoreInfo/MoreInfo';

import './FicheMentalMatrix.scss';

export const FicheMentalMatrix = (props) => {

    const [bodyItems, setBodyItems] = useState([]);

    useEffect(() => {
        let items = props.processFicheItems(props.data.body.items);
        setBodyItems(items);

    }, [JSON.stringify(props.data.body.items)]);

    return (
        <div
            class={`c-fiche c-mentalmatrix-full ${props.data?.hasDetail ? "u-has-detail" : ""}`}
            onClick={() => {
                if (props.data?.hasDetail && props.openPopup) {
                    props.openPopup(props.data.urlSegment);
                }
            }}
            data-aos="fade-up"
        >
            <div>
                <div class="image" title={`Meer over ${props.data.title}`}>
                    {props.data?.image?.url &&
                        <Image alt={props.data.title} src={(props.data.image && props.data.image.url)} />
                    }
                </div>
                <header class="c-fiche__header">
                    <h3 class="title" title="Apenspel">
                        {props.data.title}
                    </h3>
                    <p>
                        {props.data.text}
                    </p>
                </header>
                <div className='c-fiche__body'>
                    <ul class="">
                        {bodyItems}
                    </ul>
                </div>
                <MoreInfo
                    data={props.data}
                    openPopup={props.openPopup}
                    cta={props.dictionary.moreInfo}
                />
            </div>
        </div>
    );
}